module.exports = __webpack_public_path__ + "static/img/s_3.d29863c6.png";